import { Button, H2, Paragraph, Prose } from '@sbab-ui/components'

export default function ErrorMessage() {
  return (
    <Prose data-testid="error-message">
      <H2>Hoppsan, något gick fel hos oss</H2>
      <Paragraph className="!mt-0">
        Vi verkar ha ett tekniskt fel just nu. Försök gärna igen. Om det fortfarande inte fungerar
        vänta en stund och försök igen senare.
      </Paragraph>
      <Button
        variant="primary"
        size="large"
        className="mb-10 w-full sm:w-[282px]"
        onClick={() => window.location.reload()}
      >
        Försök igen
      </Button>
    </Prose>
  )
}
